var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.mostrarGeneral,
          expression: "mostrarGeneral"
        }
      ],
      staticClass: "crearGeneralMovimiento",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-form",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "div",
                            { attrs: { align: "left" } },
                            [
                              _c("v-flex", [
                                _c(
                                  "h2",
                                  {
                                    staticClass: "h2_title",
                                    staticStyle: {
                                      "margin-top": "12px !important"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Movimiento de Equipos\n                "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c("br"),
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "movimiento",
                                      label: _vm.formFields.movimiento.label,
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.formFields.movimiento.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.movimiento,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.movimiento.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "max:80",
                                        expression: "'max:80'"
                                      }
                                    ],
                                    staticClass: "mr-2",
                                    attrs: {
                                      label: _vm.formFields.usuario.label,
                                      disabled: true,
                                      counter: 80
                                    },
                                    model: {
                                      value: _vm.formFields.usuario.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.usuario,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.usuario.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      label: _vm.formFields.operacion.label,
                                      items: _vm.operaciones,
                                      "item-text": "configvalor",
                                      "item-value": "configid",
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.formFields.operacion.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.operacion,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.operacion.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      label: _vm.formFields.origen.label,
                                      items: _vm.destinos,
                                      "item-text": "tipoubicaname",
                                      "item-value": "tipoubicaid",
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.formFields.origen.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.origen,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.origen.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      label: _vm.formFields.destino.label,
                                      items: _vm.destinosPosibles,
                                      "item-text": "tipoubicaname",
                                      "item-value": "tipoubicaid"
                                    },
                                    model: {
                                      value: _vm.formFields.destino.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.destino,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.destino.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      clearable: "",
                                      label: _vm.formFields.despacho.label,
                                      items: _vm.despachos,
                                      "item-text": "despaseguimiento",
                                      "item-value": "despanumero"
                                    },
                                    model: {
                                      value: _vm.formFields.despacho.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.despacho,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.despacho.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mr-2",
                                    attrs: { label: _vm.formFields.caja.label },
                                    model: {
                                      value: _vm.formFields.caja.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.caja,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.caja.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      label: _vm.formFields.estado.label,
                                      items: _vm.estado,
                                      "item-text": "configvalor",
                                      "item-value": "configid"
                                    },
                                    model: {
                                      value: _vm.formFields.estado.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.estado,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.estado.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "max:250",
                                        expression: "'max:250'"
                                      }
                                    ],
                                    staticClass: "mr-2",
                                    attrs: {
                                      label: _vm.formFields.observacion.label,
                                      counter: 250,
                                      rules: [_vm.rules.counter]
                                    },
                                    model: {
                                      value: _vm.formFields.observacion.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.observacion,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.observacion.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }